import React from 'react';

import { BudgetSahPreview, SahCandidate } from '~support-at-home/actions/budgets';

import { MatchType } from './matchType';

interface ComponentProps {
  preview: BudgetSahPreview;
  matchType: MatchType;
  selectedSahId: string | null;
  onSelect: (budgetId: string, sahBudgetId: string) => void;
  showRowError: boolean;
}

const SahBudgetCell: React.FC<ComponentProps> = ({ preview, matchType, selectedSahId, onSelect, showRowError }) => {
  if (matchType === 'auto') return <span className="text-success">{preview.candidates[0]?.label}</span>;
  if (matchType === 'no-match') return <span className="text-muted">No matching SAH budgets</span>;
  return (
    <div className="d-flex flex-column gap-1">
      {showRowError && (
        <div className="text-danger small mb-1" role="alert">
          Select a SAH budget first
        </div>
      )}
      {(preview.candidates as SahCandidate[]).map((cand) => (
        <div key={cand.id} className="form-check mb-0">
          <input
            className="form-check-input"
            type="radio"
            id={`sah-radio-${preview.budget_id}-${cand.id}`}
            name={`sah-budget-${preview.budget_id}`}
            value={cand.id}
            checked={selectedSahId === cand.id}
            onChange={() => onSelect(preview.budget_id, cand.id)}
          />
          <label className="form-check-label" htmlFor={`sah-radio-${preview.budget_id}-${cand.id}`}>
            {cand.label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default SahBudgetCell;
